import {Injectable} from '@angular/core';
import {createRequestOption, DATE_FORMAT} from '@app/shared';
import {SERVER_API_URL} from '@app/app.constants';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IProduct, IProductBatches} from '@entities/san-pham/san-pham.model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class QrCodeService {
  private resourceUrl = SERVER_API_URL + '/api/tb-codes';
  private resourceStampUrl = SERVER_API_URL + '/api/tb-example-stamp';
  private resourceTimelineUrl = SERVER_API_URL + '/api/tb-codes-timeline';
  constructor(private http: HttpClient) {}

  query(req: any, data = {}): Observable<HttpResponse<any>> {
    const options = createRequestOption(req);
    return this.http.post(`${this.resourceUrl}/list`, data, {
      params: options,
      observe: 'response',
    });
  }

  find(productId: number): Observable<HttpResponse<IProduct>> {
    return this.http
      .get<IProduct>(`${this.resourceUrl}/${productId}`, {observe: 'response'})
      .pipe(map((res: HttpResponse<IProduct>) => res));
  }

  findTimeline(productId: number): Observable<HttpResponse<IProduct>> {
    return this.http
      .get<IProduct>(`${this.resourceTimelineUrl}/${productId}`, {
        observe: 'response',
      })
      .pipe(map((res: HttpResponse<IProduct>) => res));
  }

  create(data: any): Observable<HttpResponse<any>> {
    return this.http.post(this.resourceUrl, data, {observe: 'response'});
  }

  delete(productId: number): Observable<HttpResponse<any>> {
    return this.http.delete(`${this.resourceUrl}/${productId}`, {
      observe: 'response',
    });
  }

  update(data: any): Observable<any> {
    return this.http.put<any>(this.resourceUrl, data, {observe: 'response'});
  }

  dropdownListStamp(): Observable<HttpResponse<any>> {
    return this.http
      .get<IProduct>(`${this.resourceStampUrl}/dropdown-list`, {
        observe: 'response',
      })
      .pipe(map((res: HttpResponse<any>) => res));
  }

  exportQuery(param: any): Observable<HttpResponse<any>> {
    const req = {tbCodeValue: param};
    const options = createRequestOption(req);
    return this.http.get(`${this.resourceUrl}/export/`, {
      params: options,
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  exportPdfQuery(id: any): Observable<HttpResponse<any>> {
    return this.http.get(`${this.resourceUrl}/generateQRCode/${id}`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  updateTBCode(id: any, status: string): Observable<HttpResponse<any>> {
    const url = `${this.resourceUrl}/update/${id}/status/${status}`;
    return this.http.put<any>(url, null, {
      observe: 'response',
    });
  }
}
